
function Station() {
  return (
    <>
    <div className=" m-2  p-2 container mx-auto  shadow-lg">
      
      <div className="md:text-3xl" >
        <h1>
        Hey i am Taha Elkarroumy ,
        Passionate full stack programmer ,with  a good hands in developing scalable websites & applications using a wide range of skills like :

          <div className="text-sm font-mono font-bold">
          <h6 className=" bg-gray-100 m-1">
            <p style={{width: "80%"}} className="bg-green-300 p-2 ">Html/css/JS</p>
            
          </h6> 
          <h6 className="  bg-gray-100 m-1">
          <p style={{width: "90%"}} className="bg-green-300 p-2 "> NodeJS/React/MongoDb</p>
            </h6> 

          <h6 className="  bg-gray-100 m-1">
          <p style={{width: "70%"}} className="bg-green-300 p-2 ">  Ethereum/Blockchain dev</p>

            </h6> 
          <h6 className="  bg-gray-100 m-1">
          <p style={{width: "80%"}} className="bg-green-300 p-2 ">Python/Rust/C</p> 
            </h6> 
          </div>
        </h1>     
        </div>

        <div className="md:flex justify-center">
              <div class="max-w-sm m-2 bg-white rounded-lg border border-gray-200 shadow-md ">
                <div class="p-5">
                    <p>
                        <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900 ">Rest APIs</h5>
                    </p>
                    <p class="mb-3 font-normal text-gray-700">I have a good hands in making APIs endpoints using NodeJS , DenoJS and Python.</p>
                </div>
               </div>

                <div class="max-w-sm m-2 bg-white rounded-lg border border-gray-200 shadow-md ">

        <div class="p-5">
            <p>
                <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900 ">MERN web Applications</h5>
            </p>
            <p class="mb-3 font-normal text-gray-700">I have a good hands in making scalable web applications using the MERN stack ,  websites will be Fast and Secure thanks to this Technlogy</p>
            </div>
          </div>

          <div class="max-w-sm m-2 bg-white rounded-lg border border-gray-200 shadow-md ">
          <div class="p-5">
              <p>
                  <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900 ">Electron GUIs</h5>
              </p>
              <p class="mb-3 font-normal text-gray-700">I can make a Desktop apps using Electron JS  <br /> 
                <kbd>Linux/MAC/WIN</kbd>
              </p>
          </div>
        </div>

        </div>

      </div>

    </>
  );
}

export default Station;
